import dropdownicon from "../../assets/images/icon-arrow-light.svg";
export default function Nav({ handleToggleMenu }) {
  return (
    <article className="flex flex-row justify-between flex-auto px-8 pt-5 pb-9 phone:hidden tablet:flex">
      <div className="flex align-center">
        <h1 className="px-3 text-2xl font-bold text-white">Blogr</h1>
        <ul className="flex px-4 text-white">
          <li className="px-2">
            Product
            <img
              src={dropdownicon}
              className="inline px-1"
              onClick={() => handleToggleMenu("product")}
              alt=""
            />
          </li>
          <li className="px-2">
            Company
            <img
              className="inline px-1"
              src={dropdownicon}
              onClick={() => handleToggleMenu("company")}
              alt=""
            />
          </li>
          <li className="px-2">
            Connect
            <img
              className="inline px-1"
              src={dropdownicon}
              onClick={() => handleToggleMenu("connect")}
              alt=""
            />
          </li>
        </ul>
      </div>
      <div>
        <button className="px-3 text-white">Login</button>
        <button className="px-6 py-2 bg-white rounded-full text-bright-red">
          Sign Up
        </button>
      </div>
    </article>
  );
}
